var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79172 6.02989L2.8221 11.8735C2.98194 12.78 3.84637 13.3852 4.75286 13.2254L8.45058 12.5734M1.79172 6.02989L1.51974 4.48741C1.3599 3.58092 1.96518 2.71649 2.87167 2.55665L11.0784 1.10958C11.9849 0.949745 12.8493 1.55503 13.0092 2.46152L13.2811 4.004L1.79172 6.02989ZM13.3332 7.71749V9.66749L15.0665 11.4008M18.7499 9.66749C18.7499 12.659 16.3247 15.0842 13.3332 15.0842C10.3416 15.0842 7.91652 12.659 7.91652 9.66749C7.91652 6.67595 10.3416 4.25083 13.3332 4.25083C16.3247 4.25083 18.7499 6.67595 18.7499 9.66749Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarClock);
export default __webpack_public_path__ + "static/media/calendar-clock.d2f7796da6e827e068910bf5628af0c0.svg";
export { ForwardRef as ReactComponent };